export class SearchResources200ResponseTablesInnerSource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbEngine",
            "baseName": "dbEngine",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResources200ResponseTablesInnerSource.attributeTypeMap;
    }
    constructor() {
    }
}
